<div class="form-container">
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row">
      <div class="col-sm">
        <label for="firstName" translate>company.user.form.first-name.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('firstName')
        }">
          <input class="vox-text-field" type="text" id="firstName" formControlName="firstName" [placeholder]="'company.user.form.first-name.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="form.controls.firstName.errors?.required" class="vox-input-group__error-message" translate>
              company.user.form.first-name.required
            </span>
            <span *ngIf="form.controls.firstName.errors?.pattern" class="vox-input-group__error-message" translate>
              company.user.form.first-name.pattern
            </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label for="lastName" translate>company.user.form.last-name.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('lastName')
        }">
          <input class="vox-text-field" type="text" id="lastName" formControlName="lastName" [placeholder]="'company.user.form.last-name.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
            <span *ngIf="form.controls.lastName.errors?.required" class="vox-input-group__error-message" translate>
              company.user.form.first-name.required
            </span>
            <span *ngIf="form.controls.lastName.errors?.pattern" class="vox-input-group__error-message" translate>
              company.user.form.first-name.pattern
            </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label for="phone" translate>company.user.form.phone.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('phone')
        }">
          <input class="vox-text-field" type="text" id="phone" formControlName="phone" [placeholder]="'company.user.form.phone.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>company.user.form.phone.error</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label for="email" translate>company.user.form.email.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('email')
        }">
          <input class="vox-text-field" type="email" id="email" formControlName="email" [placeholder]="'company.user.form.email.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i>
          <span class="vox-input-group__error-message" translate>company.user.form.email.error</span>
          </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm">
        <label for="extension" translate>company.user.form.extension.label</label>
        <div class="vox-input-group vox-input-group_dense" [ngClass]="{
          'vox-input-group_invalid': isFieldValid('extension')
        }">
          <input class="vox-text-field" type="text" id="extension" formControlName="extension" [placeholder]="'company.user.form.extension.placeholder' | translate" /><i
            class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
            class="vox-input-group__error-message" translate>company.user.form.extension.error</span>
        </div>
      </div>
    </div>
    <div class="row">
      <div *ngIf="!user._isEditing" class="col-sm check-box">
        <input class="vox-checkbox" type="checkbox" [(ngModel)]="checkPassword" [ngModelOptions]="{standalone: true}"/>
        <label translate>company.user.form.check-password.label</label>
      </div>
    </div>
    <div *ngIf="checkPassword" class="row">
      <div class="col-sm">
        <label for="password" translate>company.user.form.password.label</label>
        <div class="vox-input-group vox-input-group_dense">
          <vox-password-input formControlName="password" [language]="language"></vox-password-input>
        </div>
      </div>
    </div>
    <div *ngIf="checkPassword" class="row">
      <div class="col-sm">
        <label for="password" translate>company.user.form.repeat-password.label</label>
        <div class="vox-input-group vox-input-group_dense">
          <input class="vox-text-field" type="text" id="repeatPassword" formControlName="repeatPassword" [placeholder]="'company.user.form.repeat-password.placeholder' | translate" />
        </div>
      </div>
    </div>
    <div *ngIf="checkPassword && repeatPasswordError" class="vox-inline-message vox-inline-message_light-grey">
      <div>
        <i class="icon-small-info"></i>
        <span translate>company.user.form.repeat-password.error</span>
      </div>
    </div>
    <div class="submit-container">
      <button *ngIf="!user._isEditing"
        class="vox-btn vox-btn-primary"
        [ladda]="loading"
        data-spinner-color="grey"
        data-style="zoom-in"
        [disabled]="form.invalid"
        type="submit">
        {{'company.user.form.submit-add' | translate}}
      </button>
      <button *ngIf="user._isEditing"
        class="vox-btn vox-btn-primary"
        [ladda]="loading"
        data-spinner-color="grey"
        data-style="zoom-in"
        [disabled]="enableSubmit()"
        type="submit">
        {{'company.user.form.submit-edit' | translate}}
      </button>
    </div>
  </form>
</div>
